import script from "./questionThree.vue?vue&type=script&setup=true&lang=js"
export * from "./questionThree.vue?vue&type=script&setup=true&lang=js"

import "./questionThree.vue?vue&type=style&index=0&id=2dfeefed&scoped=true&lang=scss"

import exportComponent from "D:\\a-mydemo\\houlang\\gs-demo\\keymemo-demo\\keymemory-pc-login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dfeefed"]])

export default __exports__